module.exports = __webpack_public_path__ + "media/img/illustrations/icons/badge-agency-locked-a8aeb9af1216372c70a388c5ca28aea7.svg";